import clsx from 'clsx'
import React, { FC } from 'react'

interface EventResultItemProps {
  title: string
  logo: string
  onClick: () => void
  isAvailable?: boolean
}

export const EventResultItem: FC<EventResultItemProps> = ({
  title,
  logo,
  onClick,
  isAvailable,
}) => {
  return (
    <div className="flex flex-col w-full sm:w-[49%] md:w-[32%] xl:w-[18.4%] rounded-[20px] p-5 border border-SeabiscuitLightThemeColorD3 h-[211px]">
      <h4 className="font-bold mb-2">{title}</h4>
      <img className="w-12" src={logo} alt="" />
      <div className="mt-auto flex items-center justify-between gap-2">
        {!isAvailable && <p className="text-SeabiscuitDark200ThemeColor/50">Coming soon</p>}
        <button
          type="button"
          className={clsx(
            'cursor-default ml-auto p-2.5 w-12 h-12 bg-SeabiscuitGrayThemeColor rounded-lg flex items-center justify-center',
            isAvailable && 'cursor-pointer group hover:bg-SeabiscuitMainThemeColor/5 transition-all'
          )}
          onClick={() => {
            if (isAvailable) onClick()
          }}
        >
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="fill-[#122B46] group-hover:fill-SeabiscuitMainThemeColor transition-all"
              d="M13.0001 0.5C7.65066 0.5 3.07288 3.86826 1.29357 8.60791C1.2486 8.72352 1.22703 8.84691 1.23009 8.97092C1.23315 9.09494 1.26079 9.21711 1.31141 9.33036C1.36203 9.44361 1.43462 9.5457 1.52497 9.63069C1.61533 9.71569 1.72165 9.78191 1.83778 9.82552C1.95391 9.86913 2.07755 9.88926 2.20151 9.88475C2.32548 9.88024 2.44732 9.85117 2.55998 9.79922C2.67263 9.74728 2.77385 9.6735 2.85779 9.58216C2.94172 9.49082 3.00669 9.38372 3.04894 9.26709C4.55963 5.24299 8.43707 2.375 13.0001 2.375C18.879 2.375 23.6251 7.12107 23.6251 13C23.6251 18.8789 18.879 23.625 13.0001 23.625C8.43707 23.625 4.55963 20.757 3.04894 16.7329C3.00669 16.6163 2.94172 16.5092 2.85779 16.4178C2.77385 16.3265 2.67263 16.2527 2.55998 16.2008C2.44732 16.1488 2.32548 16.1198 2.20151 16.1152C2.07755 16.1107 1.95391 16.1309 1.83778 16.1745C1.72165 16.2181 1.61533 16.2843 1.52497 16.3693C1.43462 16.4543 1.36203 16.5564 1.31141 16.6696C1.26079 16.7829 1.23315 16.9051 1.23009 17.0291C1.22703 17.1531 1.2486 17.2765 1.29357 17.3921C3.07288 22.1317 7.65066 25.5 13.0001 25.5C19.8924 25.5 25.5001 19.8923 25.5001 13C25.5001 6.10768 19.8924 0.5 13.0001 0.5ZM12.6778 8.30273C12.4913 8.30278 12.309 8.35849 12.1542 8.46273C11.9995 8.56698 11.8794 8.71502 11.8092 8.88792C11.7391 9.06081 11.7222 9.2507 11.7606 9.43328C11.7989 9.61586 11.8909 9.78284 12.0248 9.91284L14.1732 12.0613L1.43883 12.0503C1.31461 12.0484 1.19125 12.0712 1.07591 12.1174C0.960573 12.1635 0.855564 12.2322 0.766985 12.3193C0.678406 12.4064 0.608024 12.5103 0.559927 12.6248C0.51183 12.7394 0.486979 12.8623 0.486817 12.9866C0.486655 13.1108 0.511186 13.2338 0.558985 13.3485C0.606783 13.4632 0.676895 13.5672 0.765247 13.6545C0.853599 13.7419 0.958428 13.8108 1.07364 13.8573C1.18886 13.9038 1.31216 13.9269 1.43639 13.9253L14.1756 13.9363L12.0248 16.0872C11.9348 16.1735 11.863 16.277 11.8135 16.3915C11.764 16.506 11.7379 16.6292 11.7366 16.7539C11.7353 16.8787 11.759 17.0024 11.8061 17.1179C11.8532 17.2334 11.923 17.3383 12.0112 17.4265C12.0994 17.5147 12.2043 17.5844 12.3197 17.6315C12.4352 17.6787 12.5589 17.7023 12.6837 17.701C12.8084 17.6998 12.9316 17.6736 13.0461 17.6241C13.1606 17.5746 13.2641 17.5028 13.3505 17.4128L17.1005 13.6628C17.2762 13.487 17.3749 13.2486 17.3749 13C17.3749 12.7514 17.2762 12.513 17.1005 12.3372L13.3505 8.58716C13.2631 8.49717 13.1585 8.42563 13.043 8.37677C12.9274 8.32792 12.8033 8.30274 12.6778 8.30273Z"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}
